import { cn } from '@/shared/lib/cn';

/**
 * Decorative bottom-left blob matching the PowerApps splash: a deep brand-red
 * curve with a lighter soft-red overlay. Purely visual; `aria-hidden`.
 */
export function SplashBackdrop({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        'pointer-events-none absolute inset-x-0 bottom-0 h-64 overflow-hidden',
        className,
      )}
    >
      <svg
        viewBox="0 0 1440 420"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="h-full w-full"
      >
        <path
          d="M-20 260 C 180 160, 360 260, 520 230 C 700 195, 820 320, 1020 330 C 1240 340, 1360 260, 1500 280 L 1500 440 L -20 440 Z"
          fill="hsl(var(--brand-red-soft))"
          opacity="0.9"
        />
        <path
          d="M-20 330 C 160 280, 340 340, 520 320 C 720 295, 880 380, 1080 380 C 1260 380, 1380 340, 1500 350 L 1500 440 L -20 440 Z"
          fill="hsl(var(--brand-red))"
        />
      </svg>
    </div>
  );
}
